import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "bg-gray-800 rounded-lg overflow-hidden mb-4 relative shadow-lg" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "w-full h-96 flex items-center justify-center bg-gray-800 text-gray-500",
  style: {"width":"520px","height":"384px"}
}
const _hoisted_5 = {
  key: 3,
  class: "absolute inset-x-0 top-1/2 transform -translate-y-1/2 flex justify-between px-4"
}
const _hoisted_6 = {
  key: 0,
  class: "thumbnails-container"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.currentImage)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.getImageUrl(_ctx.currentImage),
            alt: _ctx.product.name,
            class: "w-full h-96 object-contain cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-lightbox')))
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[4] || (_cache[4] = [
            _createElementVNode("span", null, "Nema dostupnih slika", -1)
          ]))),
      (_ctx.currentImage)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('open-lightbox'))),
            class: "absolute top-3 right-3 bg-gray-900 bg-opacity-70 p-2 rounded-md cursor-pointer hover:bg-opacity-90 transition-opacity text-white hover:bg-blue-900"
          }, _cache[5] || (_cache[5] = [
            _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-d174e6e6><path d=\"M8 3H5a2 2 0 0 0-2 2v3\" data-v-d174e6e6></path><path d=\"M21 8V5a2 2 0 0 0-2-2h-3\" data-v-d174e6e6></path><path d=\"M3 16v3a2 2 0 0 0 2 2h3\" data-v-d174e6e6></path><path d=\"M16 21h3a2 2 0 0 0 2-2v-3\" data-v-d174e6e6></path></svg>", 1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.product?.pictures?.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.navigateToPreviousImage && _ctx.navigateToPreviousImage(...args)), ["stop"])),
              class: "bg-gray-900 bg-opacity-70 hover:bg-opacity-90 rounded-full p-2 text-white focus:outline-none transition-opacity hover:text-blue-400"
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M15 18l-6-6 6-6" })
              ], -1)
            ])),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.navigateToNextImage && _ctx.navigateToNextImage(...args)), ["stop"])),
              class: "bg-gray-900 bg-opacity-70 hover:bg-opacity-90 rounded-full p-2 text-white focus:outline-none transition-opacity hover:text-blue-400"
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M9 18l6-6-6-6" })
              ], -1)
            ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.product.pictures && _ctx.product.pictures.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.pictures, (picture) => {
            return (_openBlock(), _createElementBlock("div", {
              key: picture.id,
              onClick: ($event: any) => (_ctx.updateCurrentImage(picture.path)),
              class: _normalizeClass(["thumbnail-item", {
          'border-2 border-green-500': _ctx.currentImage === picture.path,
        }])
            }, [
              _createElementVNode("img", {
                src: _ctx.getImageUrl(picture.path),
                alt: _ctx.product.name,
                class: "w-full h-full object-cover"
              }, null, 8, _hoisted_8)
            ], 10, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}